import { useContext } from 'react'

import { ReabTimelineContext } from '@provider/Parametrization/ReabTimelineProvider'

import { IReabTimelineContext } from '@base/@types/providers/Parametrization/ReabTimelneProvider'
export default function useReabTimeline(): IReabTimelineContext {
  const context = useContext(ReabTimelineContext)

  return context
}
